import React from 'react';
import {getHTMLTypeFromFieldType, CHECKBOX_TYPE, HIDDEN_TYPE} from "v4/data/fieldTypes";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {useFormContext} from "react-hook-form";

export default function LoginField({field, formRenderMethods, isDisabled}) {
    const {t} = usePolTranslation();
    const {formState, getFieldState} = useFormContext();
    const {error} = getFieldState(field.name, formState);

    // fix attributes for React
    const clonedAttr = {...field.attr};
    if (Object.keys(clonedAttr ?? {}).length) {
        const attrReactCorrelation = {
            'autocomplete': 'autoComplete',
            'inputmode': 'inputMode',
        }

        Object.entries(clonedAttr).forEach(([key, value]) => {
            if (!attrReactCorrelation[key]) return;

            clonedAttr[attrReactCorrelation[key]] = value;
            delete clonedAttr[key];
        });
    }

    switch (field.type) {
        case HIDDEN_TYPE:
            return <input type="hidden"{...formRenderMethods.register(field.name, {value: field.value})}/>

        case CHECKBOX_TYPE:
            return (
                <div className="login__form__field-checkbox">
                    <input type={getHTMLTypeFromFieldType(field.type)}
                           id={field.name}
                           defaultValue={field.value}
                           disabled={isDisabled}
                           {...clonedAttr}
                           {...formRenderMethods.register(field.name, {
                               ...(field.constraints?.required && {required: t('required')})
                           })}
                    />
                    <label htmlFor={field.name}
                           className="login__form__field__label">
                        {t(field.label)}
                    </label>
                    {error?.message && <p className="login__form__error">{t(error.message)}</p>}
                </div>
            )

        default:
            return (
                <div className="login__form__field">
                    <label htmlFor={field.name}
                           className="login__form__field__label">
                        {t(field.label)}
                    </label>
                    <input type={getHTMLTypeFromFieldType(field.type)}
                           id={field.name}
                           className="login__form__field__input"
                           defaultValue={field.value}
                           disabled={isDisabled}
                           {...clonedAttr}
                           {...formRenderMethods.register(field.name, {
                               ...(field.constraints?.required && {required: t('required')})
                           })}
                    />
                    {error?.message && <p className="login__form__error">{t(error.message)}</p>}
                </div>
            )
    }
}
